import Adjust from '@adjustcom/adjust-web-sdk';
import { environment } from '@env/environment';
const isProdMode = environment.production;

export const ADJUST_EVENT_TYPE = {
  CAR_BOOKING_DETAIL: {
    label: 'Car_booking_detail',
    sandbox: '81i6ax',
    live: '35md3e',
  },
  CAR_CHECKOUT: {
    label: 'Car_checkout',
    sandbox: '6e460p',
    live: 'xkjjm4',
  },
  CAR_DETAIL_BOOKED: {
    label: 'Car_detail_booked',
    sandbox: 'aidmyg',
    live: '5zs3lk',
  },
  CAR_FAVOURITE_MARK: {
    label: 'Car_favourite_mark',
    sandbox: 'l3mfb5',
    live: 'fhn2n4',
  },
  CAR_HOMEPAGE_VIEW: {
    label: 'Car_homepage_view',
    sandbox: 'o83jtx',
    live: 'c299pv',
  },
  CAR_INFO_CONFIRM: {
    label: 'Car_info_confirm',
    sandbox: '6y45f2',
    live: 'ovnl8y',
  },
  CAR_ORDER_TRACKING: {
    label: 'Car_order_tracking',
    sandbox: 'qfkwjy',
    live: 'r9wdza',
  },
  CAR_ODER_TRACKING_SUCCESSFUL: {
    label: 'Car_order_tracking_successful',
    sandbox: 'j1oppa',
    live: 'ryyed8',
  },
  CAR_PAYMENT_CANCEL: {
    label: 'Car_payment_cancel',
    sandbox: 'o3vcaj',
    live: '96kpf5',
  },
  CAR_PAYMENT_FAILE: {
    label: 'Car_payment_fail',
    sandbox: 'tvqsng',
    live: 'ev2wvf',
  },
  CAR_PAYMENT_METHOD: {
    label: 'Car_payment_method',
    sandbox: '6oeksz',
    live: 'l0h9n6',
  },
  CAR_PAYMENT_WAITING: {
    label: 'Car_payment_waiting',
    sandbox: '276w90',
    live: '6zqhqf',
  },
  CAR_PROMOTION_SELECTED: {
    label: 'Car_promotion_select',
    sandbox: 'luanrg',
    live: 'lxk3il',
  },
  CAR_SEARCH: {
    label: 'Car_search',
    sandbox: 'khtaln',
    live: 'vkivr5',
  },
  CAR_SEARCH_SELECT: {
    label: 'Car_search_select',
    sandbox: 's08yng',
    live: 'lmpxqy',
  },
};

export const AdjustInstance = {
  instance: undefined as any,
  init: function () {
    if (!this.instance) {
      this.instance = Adjust;
      Adjust.initSdk({
        appToken: environment.APP_ADJUST_TOKEN || '',
        environment: isProdMode ? 'production' : 'sandbox',
        logLevel: isProdMode ? 'info' : 'verbose',
      });
    }
  },

  trackingEvent: function (eventName: string) {
    const eventData = Object.values(ADJUST_EVENT_TYPE).find((i) => i.label === eventName);
    if (!eventData?.label || !this.instance) return;

    if (eventData?.label && this.instance?.trackEvent) {
      Adjust.trackEvent({
        eventToken: isProdMode ? eventData.live : eventData.sandbox,
      });
    }
  },
  stop: function () {
    if (this.instance) Adjust.stop();
  },
};
